import React, { useState } from "react";
import api from "../api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const TemplatesPage = () => {
  const navigate = useNavigate();

  const [previewTemplate, setPreviewTemplate] = useState(null);

  const queryClient = useQueryClient();
  const { data: templates = [], isLoading } = useQuery({
    queryKey: ["templates"],
    queryFn: async () => {
      const res = await api.get("templates/show-templates");
      return res.data?.templates || [];
    },
  });

  const mutation = useMutation({
    mutationFn: async (templateId) => {
      await api.delete(`templates/delete-template/${templateId}`);
    },
    onSuccess: () => {
      alert("Template deleted successfully");
      queryClient.invalidateQueries(["templates"]);
    },
    onError: (error) => {
      alert("Failed to delete template: " + error.message);
    },
  });

  const openPreviewModal = (templateId) => {
    const template = templates.find((t) => t._id === templateId);

    console.log("preview template", template);
    if (template) {
      // Determine the best media URL from Meta synced data
      let displayUrl = null;
      const header = template.header;

      if (header && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(header.format)) {
        const example = header.example;
        if (example?.header_url && example.header_url.length > 0) {
          displayUrl = example.header_url[0];
        } else if (example?.header_handle && example.header_handle.length > 0) {
          const handle = example.header_handle[0];
          if (typeof handle === 'string' && handle.startsWith('http')) {
            displayUrl = handle;
          }
        }
      }

      // Fallback to previewUrl if no Meta URL found
      if (!displayUrl) displayUrl = template.previewUrl;

      setPreviewTemplate({
        displayUrl: displayUrl,
        header: template.header,
        body: template.body,
        footer: template.footer,
        buttons: template.buttons,
      });
    }
  };

  if (isLoading) {
    return (
      <div style={{ padding: "20px", color: "#555" }}>Loading templates...</div>
    );
  }

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f9fafb",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <h1 style={{ fontSize: "28px", fontWeight: "600", color: "#333" }}>
          Templates
        </h1>
        <button
          style={{
            padding: "4px 20px",
            borderRadius: "8px",
            backgroundColor: "#9DC33B",
            color: "white",
            fontWeight: "500",
            cursor: "pointer",
            border: "none",
          }}
          onClick={() => navigate("/addtemplate")}
        >
          + Add Templates
        </button>
      </div>

      {/* Table Card */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          border: "1px solid #ddd",
          overflow: "hidden",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <thead style={{ backgroundColor: "#f5f5f5", color: "#333" }}>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Name
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Category
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                language
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Date
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Status
              </th>
              <th
                style={{
                  textAlign: "right",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {templates.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#777",
                  }}
                >
                  No templates found
                </td>
              </tr>
            )}

            {templates.map((template) => (
              <tr
                key={template._id}
                style={{
                  borderTop: "1px solid #eee",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fafafa")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "white")
                }
              >
                <td
                  style={{ padding: "12px", fontWeight: "500", color: "#222" }}
                >
                  {template.name}
                </td>
                <td
                  style={{ padding: "12px", fontWeight: "500", color: "#222" }}
                >
                  {template.category}
                </td>
                <td
                  style={{ padding: "12px", fontWeight: "500", color: "#222" }}
                >
                  {template.language}
                </td>
                <td style={{ padding: "12px", color: "#555" }}>
                  {new Date(template.createdAt).toLocaleDateString()}
                </td>

                <td style={{ padding: "12px" }}>
                  <button
                    style={{
                      padding: "6px 14px",
                      borderRadius: "16px",
                      border: "none",
                      fontSize: "12px",
                      fontWeight: "500",
                      cursor: "default",
                      backgroundColor:
                        template.status === "PENDING"
                          ? "#fff3e0"
                          : template.status === "APPROVED"
                            ? "#e8f5e9"
                            : "#fdecea",
                      color:
                        template.status === "PENDING"
                          ? "#ff9800"
                          : template.status === "APPROVED"
                            ? "#4caf50"
                            : "#f44336",
                    }}
                  >
                    {template.status}
                  </button>
                </td>

                <td style={{ padding: "12px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <button
                      onClick={() => openPreviewModal(template._id)}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        backgroundColor: "white",
                        cursor: "pointer",
                        color: "#333",
                      }}
                    >
                      Preview
                    </button>
                    <button
                      onClick={() => {
                        if (window.confirm("Are you sure you want to delete this template?")) {
                          mutation.mutate(template._id);
                        }
                      }}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "6px",
                        backgroundColor: "#e53e3e",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {previewTemplate && (
        <div
          onClick={() => setPreviewTemplate(null)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 360,
              backgroundColor: "#f0f2f5", // Light WhatsApp grey
              borderRadius: 12,
              padding: 16,
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            }}
          >
            {/* Media Preview Section - only show if there is a display URL */}
            {previewTemplate.displayUrl && (
              <div style={{ width: '100%', marginBottom: 12, borderRadius: 8, overflow: 'hidden', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 150 }}>
                {previewTemplate.header?.format === 'VIDEO' ? (
                  <video src={previewTemplate.displayUrl} controls style={{ width: '100%', maxHeight: 200 }} />
                ) : previewTemplate.header?.format === 'DOCUMENT' ? (
                  <div style={{ padding: 20, textAlign: 'center', color: '#666' }}>
                    <div style={{ fontSize: 40, marginBottom: 8 }}>📄</div>
                    <div style={{ fontSize: 13 }}>Document Template</div>
                  </div>
                ) : (
                  <img
                    src={previewTemplate.displayUrl}
                    alt="header"
                    style={{
                      width: "100%",
                      objectFit: 'contain',
                      maxHeight: 250
                    }}
                  />
                )}
              </div>
            )}

            <div
              style={{
                backgroundColor: "white",
                borderRadius: 8,
                padding: 12,
                boxShadow: '0 1px 1px rgba(0,0,0,0.1)'
              }}
            >
              {previewTemplate.header?.format === 'TEXT' && previewTemplate.header.text && (
                <div style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 4 }}>{previewTemplate.header.text}</div>
              )}
              <p
                style={{
                  fontSize: 14,
                  color: "#222",
                  whiteSpace: "pre-line",
                  marginBottom: 8,
                }}
              >
                {previewTemplate.body}
              </p>

              {previewTemplate.footer && (
                <div
                  style={{
                    fontSize: 12,
                    color: "#777",
                    borderTop: "1px solid #f0f0f0",
                    paddingTop: 6,
                  }}
                >
                  {previewTemplate.footer}
                </div>
              )}
            </div>

            {previewTemplate.buttons?.length > 0 && (
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                }}
              >
                {previewTemplate.buttons.map((btn, i) => (
                  <button
                    key={i}
                    style={{
                      padding: "10px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                      backgroundColor: "white",
                      color: "#075e54",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    {btn.text}
                  </button>
                ))}
              </div>
            )}

            <button
              onClick={() => setPreviewTemplate(null)}
              style={{
                marginTop: 12,
                width: "100%",
                padding: 8,
                borderRadius: 6,
                border: "none",
                backgroundColor: "#e53e3e",
                color: "white",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplatesPage;
